import React from "react";
import './Error.css'; // move your CSS into a separate file

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("App crashed:", error, info);
  }

  componentDidUpdate() {
    if (this.state.hasError) {
      this.startLoader();
    }
  }

  handleRetry = () => {
    sessionStorage.removeItem("crash-reloaded");
    window.location.reload();
  };


startLoader() {
  if (this.loaderStarted) return;
  this.loaderStarted = true;

  // Always animate, even after a previous crash
  const counter = document.querySelector(".counter");
  if (!counter) return;

  // Reset counter
  counter.innerText = "0";
  const target = +counter.getAttribute("data-target");

  // Delay ensures DOM is fully painted
  setTimeout(() => {
    const NumberCounter = () => {
      const value = +counter.innerText;

      if (value < target) {
        counter.innerText = Math.ceil(value + 1);
        setTimeout(NumberCounter, 25);
      } else {
        // Only reload once
        if (!sessionStorage.getItem("crash-reloaded")) {
          sessionStorage.setItem("crash-reloaded", "true");
          setTimeout(() => window.location.reload(), 500);
        }
      }
    };

    NumberCounter();
  }, 0);

  // Build circular blocks WITHOUT removing the counter
  const rating = document.querySelector(".rating");
  if (!rating) return;

  // Remove only old blocks, not the counter
  rating.querySelectorAll(".block").forEach((b) => b.remove());

  for (let i = 1; i < 100; i++) {
    const block = document.createElement("div");
    block.className = "block";
    block.style.transform = `rotate(${3.6 * i}deg)`;
    block.style.animationDelay = `${i / 40}s`;
    rating.appendChild(block);
  }
}


  render() {
    if (!this.state.hasError) return this.props.children;

    return (
  <div className="cardBody">
    <div className="card">
      <div className="rating">
        <h2>
          <span className="counter" data-target="100">0</span>
          <sup>%</sup>
          <br />
          Reloading…
        </h2>
        <div className="block"></div>
      </div>

      <button style={{ cursor: 'pointer' }} className="retry-btn" onClick={this.handleRetry}>
        Click to Try Again
      </button>
    </div>
  </div>
);

  }
}
